/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled/macro';
import * as color from 'style/color';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import React from 'react';
import {PageTitle} from '../page-title';
import cx from 'classnames';

export const ToolDivider = styled.div(
  ({color = '#c6c7c8'}: {color?: string}) => ({
    width: 2,
    height: 25,
    margin: '0 15px',
    backgroundColor: color,
    opacity: 0.39,
  }),
);

const defaultFontColor = color.dark;
export const ToolbarButton = styled.button(
  ({
    color = defaultFontColor,
    disabled = false,
  }: {
    color?: string;
    disabled?: boolean;
  }) => ({
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    color: color,
    opacity: disabled ? 0.5 : 1,
  }),
);

export const ButtonIcon: React.FC<FontAwesomeIconProps> = ({
  className,
  ...props
}) => {
  return (
    <FontAwesomeIcon className={cx('text-sm mr-5', className)} {...props} />
  );
};

export default function PageToolBar(props: {
  children?: React.ReactNode;
  pageTitle: string | React.ReactNode;
}) {
  const {pageTitle, children} = props;
  return (
    <div
      css={{
        paddingBottom: 15,
        borderBottom: '1px solid rgba(233, 236, 237, .9)',
        display: 'flex',
        marginBottom: 15,
      }}
    >
      <PageTitle className="page-title">{pageTitle}</PageTitle>
      {children && <ToolDivider />}
      <div css={{display: 'flex', alignItems: 'center'}}>{children}</div>
    </div>
  );
}
